import { render, staticRenderFns } from "./cus-border.vue?vue&type=template&id=7ed1d49d&scoped=true"
import script from "./cus-border.vue?vue&type=script&lang=js"
export * from "./cus-border.vue?vue&type=script&lang=js"
import style0 from "./cus-border.vue?vue&type=style&index=0&id=7ed1d49d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_d79148f6156699cf80ef22aa45ce0a5c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed1d49d",
  null
  
)

export default component.exports